<div>
  <div
    [style]="{
      'background-color': statusColorsPalette[status()][0],
      color: statusColorsPalette[status()][1]
    }"
    class="mandate-status"
  >
    <span>{{ statusLabel() }}</span>
  </div>
</div>
